import * as types from './types';

export const state = {
  currentView: 'steps',
  previewStep: 'question',
  previewDevice: 'desktop',
  highlight: {
    style: {
      top: '0px',
      left: '0px',
      width: '0px',
      height: '0px',
      display: 'none',
    },
    element: null,
  },
};

export const mutations = {
  [types.CANVAS_CHANGE_VIEW](state, view) {
    state.currentView = view;
  },
  [types.CANVAS_CHANGE_PREVIEW_DEVICE](state, device) {
    state.previewDevice = device;
  },
  [types.CANVAS_ENABLE_HIGHLIGHT](state, element) {
    state.highlight.element = element;
    state.highlight.style = {
      top: `${element.offsetTop}px`,
      left: `${element.offsetLeft}px`,
      width: `${element.offsetWidth - 1}px`,
      height: `${element.offsetHeight - 1}px`,
      display: 'block',
    };
  },
  [types.CANVAS_DISABLE_HIGHLIGHT](state) {
    state.highlight.element = null;
    state.highlight.style = {
      top: '0px',
      left: '0px',
      width: '0px',
      height: '0px',
      display: 'none',
    };
  },
  [types.CANVAS_RESET_STATE](state) {
    state.currentView = 'steps';
    state.previewStep = 'question';
    state.previewDevice = 'desktop';
    state.highlight.element = null;
    state.highlight.style = {
      top: '0px',
      left: '0px',
      width: '0px',
      height: '0px',
      display: 'none',
    };
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/canvas/mutations.js
 **/